import {reactive} from "vue";
import {useRouter} from "vue-router";
import {useToastError} from "./useToastError";
import {useAuthStore} from "../store/auth";

export const useLogin = () => {
    const store = useAuthStore();
    const router = useRouter();
    const {displayErrors, toast} = useToastError();

    const loginForm = reactive({email: "", password: ""});

    const handleLogin = () => {
        window.axios.get(window.sanctumEndpoint).then(response => {
            window.axios.post("/api/login", loginForm).then(loginResponse => {
                toast.success("Signed in successfully!");
                store.login({signedIn: true, user: loginResponse.data.user});
                router.push("/");
                resetLoginForm();
            }).catch(error => {
                displayErrors(error.response);
            });
        });
    }

    const handleLogout = () => {
        window.axios.get(window.sanctumEndpoint).then(response => {
            window.axios.post("/api/logout").then(logoutResponse => {
                store.logout();
                router.push("/");
            });
        });
    }

    const resetLoginForm = () => {
        loginForm.email = "";
        loginForm.password = "";
    }

    return {
        loginForm,
        handleLogin,
        handleLogout
    }
}
